import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../common';
import { SeatCapacityLocationsList } from './seatCapacityLocationsList';
/**
 * Read-only details of seat inventory overflows for the baseline. Opened by clicking the
 * seat-exceeded icon in Summary / period / daily views (not the lock confirmation gate).
 */
export var SeatsAlertDetailsDialog = function (_a) {
  var open = _a.open,
    locations = _a.locations,
    onClose = _a.onClose;
  var t = useTranslation('translation').t;
  return _jsx(ConfirmDialog, {
    open: open,
    onClose: onClose,
    title: t('seatCapacity.detailsTitle'),
    cancelButtonText: "close",
    message: _jsx(SeatCapacityLocationsList, {
      locations: locations
    })
  });
};